<template>
  <div>
  	<el-container>
  		<el-main>
  			<el-row :gutter="20">
		  		<el-col :span="12" :offset="6">
		  			<div class="auth-header">
		  				<img src="../../assets/logo.png">
		  			</div>
		  			<div class="signup-body auth-panel">
              <h1 style="margin:0 auto; padding-top:20px; color:#666;">Login</h1>
		  				<el-form ref="form" class="auth-form"  label-position="top" label-width="100px" :model="userData">
                
                <el-form-item prop="email" label="Email">
                  <el-input placeholder="john.doe@wza.com" v-model="userData.email"></el-input>
                </el-form-item>
                <el-row :gutter="40">
                  <el-col :span="24">
                    <el-form-item label="Password">
                      <el-input type="password" v-model="userData.password"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-button @click.native="loginUser" :loading="savingData" type="primary">Login</el-button>
                <!-- <a class="to-login" href="#/signup">Don't have an account?</a> -->
                <a class="to-login" href="#/forgot-password">Forgot your password?</a>
              </el-form>
		  			</div>
		  		</el-col>
			</el-row>
  		</el-main>
	</el-container>
  </div>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
      savingData: false,
      msg: 'This is the login',
      userData:{
        email:"",
        password:""
      }
    }
  },
  mounted() {
    var user = Parse.User.current();
    if(user) {
      this.$router.push('/dashboard');
    }
  },
  methods:{
    loginUser () {
      var _this = this;
      _this.savingData = true;
      var username = this.userData.email;
      username = username.trim().toLowerCase();
      Parse.User.logIn(username, this.userData.password)
        .then( user => {
          user.fetch()
            .then(freshUser => {
              let destination = this.$route.query['destination'] || false;
              if(destination){
                this.$router.push(destination);
                return
              }
              //if(freshUser.attributes.stripeId || freshUser.attributes.promoCode){
              if(!freshUser.attributes.programs){
                this.$router.push('/dashboard/my-details');
              } else {
                this.$router.push('/dashboard/');
              }
              return
              //} else {
              //  this.$router.push('/signup/plan');
              //}
            })
            .catch(err => {
              console.log(err);
            })
          
        }).catch( err => {
          console.log(err);
          this.savingData = false;
          this.$message.error(err);
        })
    },
    goToSignup() {
      this.$router.push('/signup/plan');
    }
  }
}
</script>

<style>

</style>
